const featureFlagDefaultState = {
  loading: true,
  hasError: false,
  isEnabled: false,
};

const LOG_PREFIX = '[useFeatureFlag]';

const constants = {
  featureFlagDefaultState,
  LOG_PREFIX,
};

export default constants;
